export class CommonConstants {
    static minimalMonthlySupportCost = 79;
    static awsPremiumDiskRatioToIopsInMB = 0.256;
    static awsPremiumMaxThroughputInMB = 4_000;
    static ravenDBAnimationsUrl = "https://ravendb.net/img/animation/";
}
